import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import { type NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import type { Variable } from '../utils';

export const HighlightedVariableValue = (props: NodeViewProps) => {
  const { id } = props.node.attrs;
  const { variables } = props.extension.options;

  const variable = ((variables as Variable[]) ?? []).find((v) => v.id === id);

  if (!variable) {
    return null;
  }

  const rendered = P.run(() => {
    if (P.isNil(variable.value)) {
      return <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;
    }

    return variable.value;
  });

  // TODO: create a recipe variant for text
  return (
    <NodeViewWrapper as='span'>
      <ChakraV3.Text
        as='span'
        textDecoration='underline dotted #bfbfbf'
        textDecorationThickness='2px'
        textUnderlineOffset='2px'
        _hover={{
          textDecoration: 'underline solid #bfbfbf',
          textDecorationThickness: '2px',
          textUnderlineOffset: '2px',
        }}
        zIndex={10}
        userSelect='text'
      >
        {rendered}
      </ChakraV3.Text>
    </NodeViewWrapper>
  );
};
